import { ActionType, getType } from 'typesafe-actions';
import * as buffer from '../../actionCreators/buffer';

const initialState = null;

export default function (
  state: Menu | null = initialState,
  action: ActionType<typeof buffer>,
): Menu | null {
  switch (action.type) {
    case getType(buffer.clearBuffer): {
      return initialState;
    }
    case getType(buffer.setBufferMenu): {
      const { value } = action.payload;
      return value == null ? initialState : value;
    }
    default:
      return state;
  }
}
